import React from 'react';
import { BFFActivityReactionButtons } from './bffActivityReactionButtons';
import { BFFAnswerAdaptiveCardContent } from './bffAnswerAdaptiveCardContent';
import { BFFWebSearchButton } from './bffWebSearchButton';
export const BFFAnswerAdaptiveCard = (props) => {
    var _a;
    const [values] = React.useState({
        activity: props.activity,
        attachment: props.attachment
    });
    const channelData = values.activity.channelData || {};
    const { id } = values.activity;
    return (React.createElement("div", null,
        React.createElement(BFFAnswerAdaptiveCardContent, { content: values.attachment.content, activityId: id }),
        (((_a = channelData.allowedReactions) === null || _a === void 0 ? void 0 : _a.length) || channelData.webSearch) && (React.createElement("div", { className: "bffCardAttachment__buttonBar" },
            React.createElement(BFFActivityReactionButtons, { activityId: id, reactions: channelData.allowedReactions }),
            React.createElement(BFFWebSearchButton, { activityId: id, webSearch: channelData.webSearch })))));
};
//# sourceMappingURL=bffAnswerAdaptiveCard.js.map